<template>
  <div class="">
    <div v-if="loading" style="border: 1px solid #F0F0F0">
      <v-progress-circular :width="2" indeterminate style="color: forestgreen"/>
    </div>
    <div v-else style="border: 1px solid #F0F0F0">
      <div class="uk-padding-xsmall tm-background-muted">
        <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
          <div>
            <div class="tm-how-much-orders" :data-uk-tooltip="local_page_keys.label_client_orders_count">
              <span v-if="Number(how_much_orders) && Number(how_much_orders) <= 10">
                {{how_much_orders}}
              </span>
              <span v-else>
                10+
              </span>
            </div>
          </div>
          <div v-if="Object.keys(facesOrderSuperFunction).length > 0">
<!--            <a href="#" @click="info(facesOrderSuperFunction)" :data-uk-tooltip="facesOrderSuperFunction.RU">-->
              <img class="tm-img-icon" :src="facesOrderSuperFunction.icon" width="30" height="30" alt="" :data-uk-tooltip="facesOrderSuperFunction.RU">
<!--            </a>-->
          </div>
          <div>
            {{local_page_keys.label_ordering_instructions}}:
          </div>
        </div>
      </div>

      <div>
        <!--список-->
        <div v-if="faces !== null" class="uk-grid tm-grid-divider uk-grid-collapse uk-child-width-1-1 tm-info-list" data-uk-grid>
          <!--общее-->
          <div v-for="value of  Object.keys(faces)" :key="value.worker">
            <div class="uk-padding-small" v-if="value === 0">{{local_page_keys.label_instructions_general}}</div>
            <div class="uk-padding-small" v-else>
              <div class="uk-grid uk-grid-small uk-child-width-auto uk-flex-middle" data-uk-grid>
                <div :class="{'tm-text-line-through':getFaceInfo(value).deleted_at}" v-html="getFaceName(value)"></div>
                <div>
                  <img class="tm-img-icon tm-img-part" src="/img/icons/Users_group.svg" width="30" height="30" alt="" @click="showPhotoDialog()" @mousemove="withFacesVisible()" @mouseleave="withFacesNotVisible()">
                </div>
              </div>
            </div>
            <!--Список фукнции-->
            <div class="uk-grid tm-grid-divider uk-grid-collapse uk-child-width-1-1 tm-functions-grid" data-uk-grid>
              <!--строка функции-->
              <div v-for="(faceValue, key) of  Object.keys(faces[value])" :key="faceValue.worker" :class="faces[value][faceValue] && faces[value][faceValue]['can_be_deleted']  && ('added_manually' in faces[value][faceValue]) && faces[value][faceValue]['added_manually']? ' tm-added-function uk-animation-fade ' : ''">
                <div v-if="faceValue != 'order_super_function' && faceValue != 'order_silver_super_function' && faceValue != 'order_subscription_super_function'">
                  <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle" data-uk-grid data-uk-height-match="target: > div > div">
                    <div class="uk-width-expand">
                      <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle tm-functions-grid-row" data-uk-height-match="target: > div > div" data-uk-grid>
                        <!--1 - удаление функции-->
<!--                        <div class="uk-width-auto" v-show="false" v-if="faces[value][faceValue] && faces[value][faceValue]['can_be_deleted'] && faces[value][faceValue]['name'] && permission !== 'read'">-->
<!--                          <a href="#" @click="removeFunction(value, faces[value][faceValue])">-->
<!--                            <span class="material-icons uk-text-danger" data-uk-tooltip="Удалить функцию">clear</span>-->
<!--                          </a>-->
<!--                        </div>-->
                        <!--2 номер фукнции по-порядку-->
                        <div class="uk-width-auto">
                          <div class="uk-padding-small uk-flex uk-flex-middle">
                            <div class="tm-function-order-num">
                              {{ key + 1 }}
                            </div>
                          </div>
                        </div>
                        <!--3 - иконка-->
                        <div class="uk-width-auto">
                          <div class="uk-padding-small uk-flex uk-flex-middle">
                            <div class="uk-width-1-1">
                              <img v-if="faces[value][faceValue].icon" class="tm-img-icon" :src="faces[value][faceValue].icon" width="30" height="30" alt="">
                              <img v-else class="tm-img-icon" src="/img/images.png" width="30" height="30" alt="">
                            </div>
                          </div>
                        </div>
                        <!--4 - статусы + название фукнции-->
                        <div class="tm-width-medium_ uk-width-expand"
                             v-if="(faces[value][faceValue].capacity && (isNotEmptyStr(faces[value][faceValue].capacity)) || isNotEmptyStr(faces[value][faceValue].capacity_color)) || (faces[value][faceValue].text && isNotEmptyStr(faces[value][faceValue].text) || faces[value][faceValue].RU)">
                          <div class="uk-flex uk-flex-middle">
                            <div class="uk-grid uk-grid-collapse uk-grid-divider uk-width-1-1 uk-flex-middle" data-uk-grid :class="faces[value][faceValue].example_file && faces[value][faceValue].client_file ? 'uk-child-width-1-1' : 'uk-child-width-auto'" data-uk-height-match="target: > div > div">
                              <!--статус-->
                              <div v-if="(faces[value][faceValue].capacity && (isNotEmptyStr(faces[value][faceValue].capacity)) || isNotEmptyStr(faces[value][faceValue].capacity_color)) || (faces[value][faceValue].text && isNotEmptyStr(faces[value][faceValue].text))">
                                <div class="uk-padding-small">
                                  <div class="tm-status"
                                       v-if="(faces[value][faceValue].capacity && (isNotEmptyStr(faces[value][faceValue].capacity)) || isNotEmptyStr(faces[value][faceValue].capacity_color))"
                                       :class="faces[value][faceValue].capacity_color && faces[value][faceValue].capacity_color !== '' && faces[value][faceValue].capacity_color !== 'null' ? faces[value][faceValue].capacity_color : 'tm-status-custom'">
                                    {{ faces[value][faceValue].capacity }}
                                  </div>
                                  <div class="tm-status-custom" v-if="!isLink(faces[value][faceValue].text) && faces[value][faceValue].text !== '' ">
                                    {{ faces[value][faceValue].text }}
                                    <span class="material-icons tm-translate-button" v-if="faces[value][faceValue].text && faces[value][faceValue].text.length > 0" @click="openGoogleTranslate(faces[value][faceValue].text)">translate</span>
                                  </div>
                                </div>
                              </div>
                              <!--название функции-->
                              <div v-if="faces[value][faceValue].RU">
                                <div :class="'uk-padding-small uk-flex uk-flex-middle ' + faces[value][faceValue].deleted && faces[value][faceValue].deleted === true ? 'tm-text-line-through' : ''">
                                  {{ faces[value][faceValue].RU }}
                                  <span v-if="faces[value][faceValue].multiplier >= 2" :data-uk-tooltip="'title:' + local_page_keys.multiplier_tooltip" class="tm-status tm-status-small">
                                    x{{ faces[value][faceValue].multiplier }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--5 - Скачать-->
                        <div class="uk-width-auto" v-if="faces[value][faceValue].example_file">
                          <div class="uk-padding-small uk-flex uk-flex-middle">
                            <div v-if="typeof (faces[value][faceValue].example_file) === 'object'" class="uk-width-1-1">
                              <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center" v-for="url of  faces[value][faceValue].url_example" :key="url.value">
                                <div>
                                  <img
                                      class="tm-img-icon tm-img-part"
                                      src="/img/icons/Face/File.svg"
                                      width="30" height="30" alt="">
                                </div>
                                <div v-if="!downloading || (downloading && !downloadingUrl.includes(url)) && downloadingUrl.length == 0">
                                  <a
                                      href="javascript:void(0);"
                                      class="tm-link-underline tm-link-reset 1"
                                      @click="downLoadExamplefile(url, (faceValue + '_example'))">
                                    {{local_page_keys.label_instructions_button_download}}
                                  </a>
                                </div>
                                <div v-else-if="(downloading && !downloadingUrl.includes(url) && downloadingUrl.length > 0)">
                                  <a
                                      href="javascript:void(0);"
                                      class="tm-link-underline tm-link-reset 2"
                                      @click="showAlert">
                                    {{local_page_keys.label_instructions_button_download}}
                                  </a>
                                </div>
                                <div v-else>
                                  <v-progress-circular
                                      :width="2"
                                      indeterminate
                                      style="color: forestgreen"
                                  ></v-progress-circular>
                                </div>
                              </div>
                            </div>
                            <div v-else-if="faces[value][faceValue].example_file && faces[value][faceValue].example_file !== ''" class="uk-width-1-1">
                              <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"
                                   @mouseover="zonephoto( '/img/images.png', faces[value][faceValue].example_file)"
                                   @mouseleave="zonephotoLeave(faces[value][faceValue].example_file)" style="cursor: pointer"
                              >
                                <div>
                                  <img
                                      class="tm-img-icon tm-img-part"
                                      src="/img/icons/Face/File.svg"
                                      width="30" height="30" alt=""
                                  />
                                </div>
                                <div v-if="!downloading || (downloading && !downloadingUrl.includes(faces[value][faceValue].example_file)) && downloadingUrl.length == 0">
                                  <a
                                      href="javascript:void(0);"
                                      class="tm-link-underline tm-link-reset 3"
                                      @click="downLoadExamplefile(faces[value][faceValue].example_file, (faceValue + '_example'))">
                                    {{local_page_keys.label_instructions_button_download}}
                                  </a>

                                </div>
                                <div v-else-if="(downloading && !downloadingUrl.includes(faces[value][faceValue].example_file) && downloadingUrl.length > 0)">
                                  <a
                                      href="javascript:void(0);"
                                      class="tm-link-underline tm-link-reset 4"
                                      @click="showAlert">
                                    {{local_page_keys.label_instructions_button_download}}
                                  </a>
                                </div>
                                <div v-else>
                                  <v-progress-circular
                                      :width="2"
                                      indeterminate
                                      style="color: forestgreen"
                                  ></v-progress-circular>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--6 - Зона-->
                        <div class="uk-width-auto" v-if="faces[value][faceValue].client_file">
                          <div class="uk-padding-small uk-flex uk-flex-middle">
                            <div v-if="typeof (faces[value][faceValue].client_file) === 'object'" class="uk-width-1-1">
                              <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"
                                   @mousemove="zonephoto(url)"
                                   @mouseleave="zonephotoLeave()"
                                   style="cursor: pointer"
                                   v-for="url of  faces[value][faceValue].client_file" :key="url.value">
                                <div>
                                  <img
                                      class="tm-img-icon tm-img-part"
                                      src="/img/icons/Face/File.svg"
                                      width="30" height="30" alt=""
                                  >
                                </div>
                                <div>
                                  <a
                                      href="javascript:void(0);"
                                      class="tm-link-underline tm-link-reset"
                                      @click="showPhotoDialog(url)"
                                  >
                                    {{local_page_keys.label_instructions_area}}
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div v-else-if="faces[value][faceValue].client_file && faces[value][faceValue].client_file !== '' && faces[value][faceValue].client_file !== 'url' " class="uk-width-1-1">
                              <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"
                                   @mousemove="zonephoto(faces[value][faceValue].client_file)"
                                   @mouseleave="zonephotoLeave()"
                                   style="cursor: pointer"
                              >
                                <div>
                                  <img
                                      class="tm-img-icon tm-img-part"
                                      src="/img/icons/Face/File.svg"
                                      width="30" height="30" alt=""
                                  >
                                </div>
                                <div>
                                  <a
                                      href="javascript:void(0);"
                                      class="tm-link-underline tm-link-reset"
                                      @click="showPhotoDialog(faces[value][faceValue].client_file)"
                                  >
                                    {{local_page_keys.label_instructions_area}}
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div class="uk-width-1-1"
                                 v-if="faces[value][faceValue].client_file && faces[value][faceValue].client_file !== '' && downloadingFunctions.includes(faceValue)">
                              <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center">

                                <div>
                                  <img
                                      class="tm-img-icon tm-img-part"
                                      src="/img/icons/Face/File.svg"
                                      width="30" height="30" alt="">
                                </div>
                                <div>
                                  <a
                                      :href="faces[value][faceValue].client_file"
                                      target="_blank"
                                      class="tm-link-underline tm-link-reset 1"
                                  >
                                    {{ local_page_keys.label_instructions_button_download }}
                                  </a>
                                </div>
                              </div>

                            </div>

                          </div>
                        </div>
                        <!--7 -Цветные заметки-->
                        <div class="uk-width-auto" v-if="faces[value][faceValue].color_notes && faces[value][faceValue].color_notes.image">
                          <div class="uk-padding-small uk-flex uk-flex-middle">
                            <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"
                                 @mousemove="zonephoto(faces[value][faceValue].color_notes.image)"
                                 @mouseleave="zonephotoLeave()"
                                 style="cursor: pointer"
                            >
                              <div>
                                <img
                                    class="tm-img-icon tm-img-part"
                                    src="/img/icons/Face/File.svg"
                                    width="30" height="30" alt=""
                                >
                              </div>
                              <div>
                                <a
                                    href="javascript:void(0);"
                                    class="tm-link-underline tm-link-reset"
                                    @click="showColorNotesDialog(faces[value][faceValue].color_notes)"
                                >
                                  {{ local_page_keys.label_instructions_area }}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--7 - инфо-->
                    <div class="uk-width-auto">
                      <div class="uk-padding-small uk-text-center uk-flex uk-flex-middle">
                        <div class="uk-width-1-1">
                          <a href="#" class="md-simple" @click="info(faces[value][faceValue])">
                            <span class="material-icons">feedback</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--диалоговое окно "главное фото до with faces"-->
    <md-dialog
        class="tm-gal-dialog"
        :md-active.sync="showDialog10"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true">
      <div class="uk-padding uk-position-relative tm-modal-page 1">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="showDialog10 = false">
          <span class="material-icons">close</span>
        </a>

        <div class="tm-block-img uk-text-center tm-width-1-1 defore-after-block">
          <img class="alter-photo"
               v-if="modal_photo !== null"
               :src="modal_photo" alt="">
          <img class="alter-photo" v-else src="/img/images.png" alt="">
        </div>

      </div>
    </md-dialog>
    <!--иифо диалоговое окно-->
    <FunctionInfoDialog
        :name="info_name"
        :text="info_text"
        :video="info_video"
        :show="showDialog"
        :items="items"
        :function_name = "info_function_name"
        :showDialogFaceValue="computedFaceValue"
        @hide="showDialog = false"/>
    <!--диалоговое окно "Галерея примеров"-->
    <FunctionGalleryDialog
        :currentIndex="currentExampleCarouselIndex"
        :parent_function_name="info_function_name"
        :show="showDialog6"
        :items="items"
        :showDialogFaceValue="computedFaceValue"
         @hide="showDialog6 = false"
        @catchOnHide="handleHideEvent"
    />
    <!--диалоговое окно c цветными метками-->
    <ColorNotesDialog
        :modalColorNotesData="modalColorNotesData"
        :showDialog11="showDialog11"
        @hide="showDialog11 = false"/>
  </div>
</template>
<script>
import FunctionInfoDialog from "@/pages/Dashboard/Components/Dialogs/FunctionInfoDialog";
import FunctionGalleryDialog from "@/pages/Dashboard/Components/Dialogs/FunctionGalleryDialog";
import ColorNotesDialog from "@/pages/Dashboard/Components/Dialogs/ColorNotesDialog";
import DownloadExampleMixin from "@/mixins/DownloadExampleMixin";
import LangMixin from "@/mixins/lang-mixin";

export default {
  name: "RetouchersInfoBlock",
  props: {
    main_photo_before_with_faces: {
      type: String,
      require: true,
    },
    how_much_orders: {
      type: Number,
      require: true,
    },
    order_id: {
      type: Number,
      require: true,
    },
    permission: {
      type: String
    }
  },
  mixins: [DownloadExampleMixin, LangMixin],
  components: {
    FunctionInfoDialog, FunctionGalleryDialog, ColorNotesDialog
  },

  data: () => ({
    createFinanceblock: true,
    loading: true,
    finance_info: [],
    faces: [],
    downloading: false,
    downloadingUrl: [],
    showDialog10: false,
    showDialog6: false,
    showDialog: false,
    modal_photo: null,
    info_name: "",
    info_function_name:"",
    info_text: "",
    info_video: "",
    timeMin: 0,
    showDialogFaceValue:{},
    items: [
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
    ],
    statusClass: '',
    baseUrl: '',
    currentExampleCarouselIndex:0,
    facesOrderSuperFunction:{},
    getterKey: 0,
    hoverLeaveExample:{},
    showDialog11: false,
    modalColorNotesData: null,
    classDisplay: '',
    downloadingFunctions: [
      'order_change_background',
      'order_photo_frame',
      'order_individual_retouch',
      'order_swap_faces',
      'order_individual_face_retouch',
      'order_individual_add_object',
      'order_individual_background_retouch',
      'order_body_individual_retouch',
    ],
    facesInfo: []
  }),

  methods: {
    handleHideEvent(payload){
      if ('parent_function_obj' in payload && payload.parent_function_obj
          &&  Object.keys( payload.parent_function_obj).length > 0) {
        this.info( payload.parent_function_obj)
      }
    },
    getOrderSuperFunction(){
      let filterKey;
      let filterName;
      const facesObjFiltered = Object.fromEntries(
          Object.entries(this.faces).filter(([key, value]) => {
                let filtered = {};
                ['order_super_function', 'order_silver_super_function', 'order_subscription_super_function'].forEach(function(name){
                  if(value.hasOwnProperty(name)){
                    filterKey = key;
                    filterName = name;
                    filtered =  value[name];
                  }
                });
                return Object.keys(filtered).length > 0;
              }
          ));
      if(filterKey in facesObjFiltered && filterName in facesObjFiltered[filterKey]) {
        this.facesOrderSuperFunction = facesObjFiltered[filterKey][filterName];
      }
    },
    async fetchOrderInfoBlock() {
      try {
        await this.$store.dispatch("order/financeBlockForRetoucher", {order_id: this.order_id});
        let data = await this.$store.getters['order/financeBlockForRetoucher'];
        /* eslint-disable no-console */
        /* eslint-enable no-console */
        if (data && data.status !== 'error') {
          if (typeof (data) !== 'string') {
            this.$emit('order_cost_credits', data.order_cost_credits);
            this.finance_info = data.finance_select;
            // this.faces = data.order_info_block.order_functions;
          }
          this.loading = false;
          this.$emit('loading', false)
        } else {
          this.createFinanceblock = false;
          this.errors = this.local_page_keys.alert_failed_infoBlock;
          this.loading = false;
          this.$emit('loading', false)
        }
      } catch (e) {
        this.createFinanceblock = false;
        this.loading = false;
        this.$emit('loading', false)
        alert(e);
      }
    },

    async zonephoto( url, example = false) {
      if(example) {
        if(example in this.hoverLeaveExample) delete this.hoverLeaveExample[example];
        let getUrl =  await this.downloadImgData( example);
        if(getUrl && 'path_img_tiny' in getUrl && 'path_img_tiny_exists' in getUrl && getUrl.path_img_tiny_exists){
          url = getUrl.path_img_tiny;
        }
      }
      if(!(example in this.hoverLeaveExample)){
        if(url) url = url.replace('dl=0', 'raw=1');
        this.$emit('zone_photo', url);
        this.$emit('zone-visible', true);
        this.$emit('after-visible', false);
      }
    },
    zonephotoLeave(example) {
      if(example) this.hoverLeaveExample[example] = true;
      this.$emit('zone_photo', null);
      this.$emit('zone-visible', false);
      this.$emit('after-visible', true);
    },

    withFacesVisible() {
      this.$emit('with-faces-visible', true)
      this.$emit('after-visible', false);
    },
    withFacesNotVisible() {
      this.$emit('with-faces-visible', false)
      this.$emit('after-visible', true);
    },
    showPhotoDialog(url) {
      let redoneUrl = '';
      if (url && typeof (url) === 'string') {
        redoneUrl = url.replace('dl=0', 'raw=1');
      }
      this.modal_photo = (url && redoneUrl !== '') ? redoneUrl : this.main_photo_before_with_faces;
      this.showDialog10 = true;
    },
    showAlert() {
      alert(this.local_page_keys.alert_wait_until_the_previous_files_are_downloaded);
    },
    info(faceValue) {
      this.$nextTick( () => {
        this.showDialogFaceValue = faceValue;
        this.info_name = faceValue.RU;
        this.info_function_name = faceValue.name;
        this.info_text = faceValue.instruction_text;
        this.info_video = faceValue.videos;
        this.items = faceValue.links;
        this.showDialog = true;
      })
    },
    isNotEmptyStr(str){
      return typeof str == 'string' && str !== '';
    },
    async fetchFunctionsList() {
      await this.$store.dispatch('order/orderFunctionsBlock', {order_id: this.order_id, 'with-deleted': true})
      let data = this.$store.getters['order/orderFunctionsBlock'];
      this.faces = data.order_functions;
      this.facesInfo =  data.faces_info;
      this.$emit('faces', this.faces);
      this.$emit('create_activities_buttons', true);
      this.getOrderSuperFunction();
    },
    isLink(data) {
      let str = '';

      if (data && data !== '') {
        str = data;
      }

      return str.includes('.com');
    },
    async downloadImgData(example) {
      await  this.$store.dispatch('loading/setLoading', true);
      await this.$store.dispatch("order/downloadExample", 'get_only_links_' + example);
      await  this.$store.dispatch('loading/setLoading', false);
      this.getterKey++;
      return  await this.$store.getters['order/downloadExample'](this.getterKey);
    },
    showColorNotesDialog(data) {
      this.modalColorNotesData = data
      this.showDialog11 = true;
    },
    getFaceName(value) {
      return value > 0 ? this.local_page_keys.label_instructions_face + ' ' + value + ':' : this.local_page_keys.common;
    },
    getFaceInfo(face) {
      return this.facesInfo.find(element => element.face === String(face))
    },
  },
  computed:{
    computedFaceValue(){
      return this.showDialogFaceValue;
    },
  },
  async created() {
    this.baseUrl = process.env.VUE_APP_API_BASE_URL.replace('api/v1', '');
    await this.fetchOrderInfoBlock();
    await this.fetchFunctionsList();
  },
}
</script>

<style>
/*Layout*/
@import '../../../../assets/css/uikit/grid.css';
/*Utilities*/
@import '../../../../assets/css/uikit/width.css';
@import '../../../../assets/css/uikit/height.css';
@import '../../../../assets/css/uikit/flex.css';
@import '../../../../assets/css/uikit/margin.css';
@import '../../../../assets/css/uikit/padding.css';
@import '../../../../assets/css/uikit/position.css';
@import '../../../../assets/css/uikit/utility.css';
@import '../../../../assets/css/uikit/transition.css';
@import '../../../../assets/css/uikit/text.css';
@import '../../../../assets/css/uikit/overlay.css';
@import '../../../../assets/css/custom.css';

</style>